import { useCallback, useContext, useEffect, useState } from 'react';
import useUser from '../../api/hooks/useUser';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import Loader from '../Loader';
import { useForm } from 'react-hook-form';
import CustomInput from '../inputs/CustomInput';
import useCategory from '../../api/hooks/useCategory';
import { styled } from '@mui/material/styles';
import useOffer from '../../api/hooks/useOffers';
import { Checkbox } from '@mui/material';

const ChangeSites = (props: any) => {

    const { isMobile } = useIsMobile();
    const changeSitesForm = useForm();
    const { user, userTreated } = useContext(MainContext);
    const { RESPONSES: RESPONSEcatgeory, RESULTS: RESULTcatgeory, CTAs: CTAsCategory } = useCategory();
    const { RESPONSES: RESPONSEoffer, RESULTS: RESULToffer, CTAs: CTAsOffer } = useOffer();
    const [categories, setCategories] = useState<any>([]);
    const [sites, setSites] = useState<{ name: string; id: number }[]>([]);
    const [selectedSites, setSelectedSites] = useState<{ id: number }[]>([]);

    useEffect(()=>{
        changeSitesForm.setValue("sites",[]);
    },[]);

    useEffect(() => {
        /* console.log(RESPONSES.getUsersListResponse, RESULTS.getUsersListResult); */
        if (RESPONSEoffer.getSitesResponse?.ok) {
            console.log(RESULToffer.getSitesResult);
            setSites(
                RESULToffer.getSitesResult.map((item: any) => ({
                    id: item.id,
                    name: item.site,
                }))
            );
        }
    }, [RESPONSEoffer.getSitesResponse]);

    useEffect(() => {
        CTAsCategory.getCategory();
        CTAsOffer.getSites();
    }, []);

    useEffect(() => {
        if (RESPONSEcatgeory.getCategoriesResponse?.ok) {
            setCategories([
                {
                    name: 'Tutti',
                    id: 'null',
                },
                ...RESULTcatgeory.getCategoriesResult.map((item: any) => ({
                    id: Number(item.id),
                    name: item.name,
                })),
            ]);
        }
    }, [RESPONSEcatgeory.getCategoriesResponse, RESULTcatgeory.getCategoriesResult]);

    useEffect(()=>{
        if(RESPONSEoffer.changeSitesResponse?.ok){
            alert("elaborazione degli oggetti avviata con successo, montirorare dal pannello di ricerca lo stato di pubblicazione.");
        }
    }, [RESPONSEoffer.changeSitesResponse, RESULToffer.changeSitesResult]);

    const onChangeSites = async (obj: any) => {
       CTAsOffer.changeSites(obj);
    }

    const selectSite = (site_id_: number, selected: boolean) => {
        if (selected) {
            if (selectedSites.filter(s => s.id === site_id_).length === 0) {
                selectedSites.push({ id: site_id_ });
                setSelectedSites([...selectedSites]);
            }
        } else {
            if (selectedSites.filter(s => s.id === site_id_).length > 0) {
                var reduced_aray = selectedSites.filter(s => s.id !== site_id_);
                setSelectedSites(reduced_aray);
            }
        }
        changeSitesForm.setValue("sites", selectedSites);
    };

    const renderSites = sites.map((site, key) => {
        return (
            <div key={key} className='user-card'>
                <p style={{ fontFamily: 'Roboto' }}>{site.name}</p>
                <Checkbox title='default' style={{ height: '30px', paddingLeft: '80px' }} checked={selectedSites.filter(s => s.id === site.id).length > 0} onChange={(e) => selectSite(site.id, e.currentTarget.checked)} />

                {/* <img
                    style={{
                        cursor: 'pointer',
                        marginLeft: 'auto',
                        marginRight: isMobile ? '' : '20px',
                    }}
                    src={`${toIcons}/close.svg`}
                    onClick={() => handelOnDeleteClick(site.id)}
                /> */}
            </div>
        );
    });

    return (
        <div
            className='users-table shadow'
            style={{
                width: isMobile ? '345px' : '',
                margin: isMobile ? '35px 16px' : '',
            }}
        >
            <div className='user-table-header-title-box' style={{ paddingLeft: "20px" , paddingTop:"30px"}}>
                    <p className='user-table-header-title'>Sites Operations</p>
                    <p className='user-table-header-description'>Riassegnazione massiva dei siti di vendita</p>
                </div>
            <div >
                <form onSubmit={changeSitesForm.handleSubmit(onChangeSites)} style={{ paddingLeft: "20px" }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '20px 0px' }}>
                        <CustomInput
                            title={'From Id'}
                            name='from_id'
                            width={isMobile ? '100%' : 150}
                            type='text'
                            register={changeSitesForm.register}
                            errors={changeSitesForm.formState.errors}
                            defaultValue={-1}
                        />
                        <CustomInput
                            title={'To Id'}
                            name='to_id'
                            width={isMobile ? '100%' : 150}
                            type='text'
                            register={changeSitesForm.register}
                            errors={changeSitesForm.formState.errors}
                            defaultValue={-1}
                        />
                        <CustomInput
                            title={'Categoria'}
                            name='category_id'
                            width={isMobile ? '100%' : 150}
                            type='select'
                            options={categories}
                            register={changeSitesForm.register}
                            errors={changeSitesForm.formState.errors}
                            defaultValue={-1}
                            idValue={true}
                        />

                    </div>
                    <div style={{ display: 'block', alignItems: 'center', gap: 10, margin: '20px 0px' }}>
                        {renderSites}
                    </div>
                    <button
                        className='modal-button'
                        style={{
                            background: 'red',
                            color: 'white',
                            margin: 0,
                            opacity: selectedSites.length > 0 ? 1 : 0.3,
                            pointerEvents: selectedSites.length > 0 ? 'auto' : 'none',
                        }}
                        type={"submit"}
                    >
                        <p className='add-buttonText'>Re-Sync</p>
                    </button>
                </form>
            </div>

        </div>
    );
};

export default ChangeSites;